module.exports = __webpack_public_path__ + "static/media/Inter-Bold.0564381b.woff2";